import { usePageContext } from 'vike-react/usePageContext';

interface JsonLdProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
}

export function JsonLd({ schema }: JsonLdProps) {
  const { cspNonce } = usePageContext() as { cspNonce?: string };
  const data = Array.isArray(schema) ? schema : [schema];
  return (
    <>
      {data.map((entry, idx) => (
        <script
          key={idx}
          type="application/ld+json"
          nonce={cspNonce}
          dangerouslySetInnerHTML={{ __html: JSON.stringify(entry) }}
        />
      ))}
    </>
  );
}
